<template>
  <nav :class="className">
    <div class="container">
      <!-- Start Logo Header Navigation -->
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
          <i class="fa fa-bars"></i>
        </button>
        <router-link to="/" class="navbar-brand">
          <img src="/img/acca-logo-pc-01.svg" width="100" class="logo logo-scrolled" alt="">
        </router-link>
      </div>
      <!-- End Logo Header Navigation -->
      <div class="collapse navbar-collapse" id="navbar-menu">
        <ul class="nav navbar-nav navbar-right menu-normal">
          <li class="br-right">
            <span><a href="https://jobs.accaglobal.com/"> ACCA Careers Global</a></span>
            <img src="/img/acca-logo-pc-02.svg" width="260" class="logo logo-scrolled" alt="">
          </li>
        </ul>
        <ul class="nav navbar-nav navbar-right menu-res">
          <li>
            <button type="button" data-toggle="collapse" data-target="#navbar-menu">
              <span class="theme-cl"><i class="ti ti-arrow-left"></i> 隐藏菜单</span>
            </button>
          </li>
          <li class="" v-if="isLogedIn">
            <a href="/portal/?desktop=true#/my-resume" target="_blank">{{ displayResumeStatus }}</a>
          </li>
          <li class="" v-if="isLogedIn">
            <router-link to="/my_applications">应聘记录</router-link>
          </li>
          <li class="" v-if="isLogedIn">
            <a href="javascript:void(0)" @click="signOut">{{ $t('nav.signout') }}</a>
          </li>

          <li class="" v-if="!isLogedIn">
            <a href="javascript:void(0)" @click="login">登录</a>
          </li>
        </ul>
      </div>
    </div> 
    <div class="container"> 
      <!-- Collect the nav links, forms, and other content for toggling -->
      <div class="collapse navbar-collapse" id="navbar-menu">
        <ul class="nav navbar-nav navbar-left" data-in="fadeInDown" data-out="fadeOutUp">
          <li class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{ $t('nav.jobs') }}</a>
            <ul class="dropdown-menu">
              <li><router-link to="/jobs">{{ $t('nav.browse-jobs') }}</router-link></li>
              <li><a href="javascript:void(0)" data-toggle="modal" data-target="#subscribe">{{ $t('nav.subscribe') }}</a></li>
            </ul>
          </li>
          
          <li class="">
            <router-link :to="'/jobs?featured=1&t=' + Date.now()" class="dropdown-toggle" data-toggle="dropdown">{{ $t('nav.featured') }}</router-link>
          </li>

          <li class="">
            <router-link :to="'/jobs?intern=1&t=' + Date.now()" class="dropdown-toggle" data-toggle="dropdown">实习生专区</router-link>
          </li>
          
          <li class="">
            <router-link to="/blogs">{{ $t('nav.consult') }}</router-link>
          </li>

        </ul>
        <ul class="nav navbar-nav navbar-right">
          <li class="sign-up dropdown" v-show="displayUser"><a class="btn btn-signup white-btn dropdown-toggle" data-toggle="dropdown"  @click="login"><span>{{ displayUser }}</span></a>
            <ul class="dropdown-menu" v-if="isLogedIn">
              <li><a href="/portal/?desktop=true#/my-resume" target="_blank">{{ displayResumeStatus }}</a></li>
              <li><router-link to="/my_applications">应聘记录</router-link></li>
              <li><a href="javascript:void(0)" @click="signOut">{{ $t('nav.signout') }}</a></li>
            </ul>
          </li>
          <li class="sign-up" style="padding-left:10px" v-show="!displayUser"><a class="btn btn-signup red-btn" :href="loginUrl"><span>登录/注册</span></a>
            
          </li>
          <li class="sign-up dropdown" style="padding-left:10px"><a class="btn btn-signup red-btn dropdown-toggle" data-toggle="dropdown"><span>我要招聘</span></a>
            <ul class="dropdown-menu">
              <li><a href="https://login.accacnjobs.com" target="_blank">雇主登录</a></li>
              <li><a href="https://www.accacnjobs.com/#/register.html" target="_blank">雇主注册</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- /.navbar-collapse -->
    </div>  
  </nav>
</template>
<style scoped>
   @media only screen and (min-width:993px) {
     .navbar-brand .logo { 
        padding: 8px 0;
     }
     #navbar-menu {
      margin-left: -15px;
     }
   }
   .br-right .logo { padding: 40px 0; }
   .menu-res {
    [data-toggle="collapse"] {
      border: none;
      background: none;
      height: 80px;
      width: 100%;
      text-align: center;
      .ti-arrow-left {
        vertical-align: -18%;
        font-size: 1.4em;
      }
    }
   }
   .navbar-collapse.in {
    -webkit-box-shadow: 5px 0px 12px 0px rgba(0,0,0,0.44); 
    box-shadow: 5px 0px 12px 0px rgba(0,0,0,0.44);
   }
</style>
<script>
export default {
  name: 'Nav',
  props: ['className'],
  components: {
  },
  computed: {
    isLogedIn: function() {
      return !!this.$store.state.user
    },
    loginUrl: function() {
      //let path = this.$route.path
      let url = this.API_PREFIX + '/api/acca/signin?redirect_url=' + encodeURIComponent(window.location.href)
      return url
    },
    displayUser: function() {
      if (this.isLogedIn)
        return this.$store.state.user
      else
        return null
    },
    displayResumeStatus: function() {
      let n = this.$t('nav.edit-profile')
      if (!this.$store.state.myResume)
        n = this.$t('nav.create-profile')
      return n
    }
  },
  methods: {
    login: function() {
      if (!this.isLogedIn)
        window.location = this.loginUrl
    },
    signOut: function() {
      let that = this
      this.$http.get(this.API_PREFIX + '/account/signout').then(() => {
        that.$store.commit('signOut')
    })
    }
  },
  mounted: function() {
    //bootsnav.hoverDropdown();
  },
  created: function() {
    //fix bootsnav bug, 2019-02-21
    //remove event
    $(window).unbind('scroll');
    if(this.className.indexOf('no-background') != -1)
      $(window).on("scroll", function(){
          var scrollTop = $(window).scrollTop();
          if(scrollTop >34){
              $(".navbar-fixed").removeClass("no-background");
          }else {
              $(".navbar-fixed").addClass("no-background");
          }
      });
  }
}
</script>